import actions from './actions'
const sesOverallAgreed = sessionStorage.getItem('agreed')

const initialState = {
  id: '',
  name: '',
  role: 'guest',
  email: '',
  avatar: '',
  authorized: false,
  loading: false,
  tenantId: 0,
  privacyAgreed: false,
  eulaAgreed: sesOverallAgreed !== null ? sesOverallAgreed : false
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
